import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useMemo } from "react";
import { ParameterInput, ParameterInputGroup, } from "ui/components/elements/parameter-input";
import { selectors, useAppSelector } from "store";
import { EditFieldTooltip } from "ui/components/panels/canvas/overlay-elements/tooltip-components/edit-field-tooltip";
import { isGroup } from "store/system-data/helpers";
export var EditParameterTooltip = function (_a) {
    var anchorElement = _a.anchorElement, parameterNames = _a.parameterNames, disabled = _a.disabled;
    var systemDataDefineParameters = useAppSelector(selectors.selectSystemDataDefineParameters);
    var groupIds = Object.keys((systemDataDefineParameters === null || systemDataDefineParameters === void 0 ? void 0 : systemDataDefineParameters.parameterGroups) || {});
    var allParametersAndGroups = useAppSelector(selectors.selectParametersGroupedInSubGroups(groupIds));
    var parametersToShow = useMemo(function () {
        if (!systemDataDefineParameters) {
            return [];
        }
        return parameterNames
            .filter(function (name) { return systemDataDefineParameters.parameters[name] !== undefined; })
            .map(function (name) { return systemDataDefineParameters.parameters[name]; });
    }, [systemDataDefineParameters, parameterNames]);
    var groupsToShow = allParametersAndGroups.filter(function (paramOrGroup) {
        return isGroup(paramOrGroup) &&
            paramOrGroup.parameters.some(function (parameter) {
                return parametersToShow.includes(parameter);
            });
    });
    var parametersInGroups = groupsToShow.flatMap(function (group) { return group.parameters; });
    var parametersWithoutGroup = parametersToShow.filter(function (parameter) { return !parametersInGroups.includes(parameter); });
    return (_jsxs(EditFieldTooltip, { anchorElement: anchorElement, disabled: disabled, children: [parametersWithoutGroup.map(function (parameter, i) { return (_jsx(ParameterInput, { parameter: parameter, autoFocus: i === 0 }, parameter.id)); }), groupsToShow.map(function (group) {
                var parametersInGroupToShow = group.parameters.filter(function (parameter) {
                    return parametersToShow.includes(parameter);
                });
                return (_jsx(ParameterInputGroup, { properties: group.properties, children: parametersInGroupToShow.map(function (param) { return (_jsx(ParameterInput, { parameter: param }, param.id)); }) }, group.id));
            })] }));
};
